<template>
  <div class="l-flex-row">
    <template v-for="(volume, i) in volumes">
      <div v-if="typeof volume.value === 'number'" :key="i" class=" bg-green-500 transition-all duration-500 ease-out" style="margin-right: 25px">
        <Tooltip :placement="tooltipPlacement">
          <template #content>
            <div>
              <label v-if="!isOpen">{{ volume.label }}</label> <b>{{ volume.formatedValue }}</b>
            </div>
          </template>
          <div class="volume-legend">
            <span class="volume-legend__item" :style="{ background: chartColors[volume.key] }">
              <svg-icon :size="iconSize(volume)" :name="volume.icon" />
            </span>
            <span class="volume-legend__label">{{ volume.label }}</span>
            <div class="volume-box-value" v-if="formulaVolumesLoading">
              <spinner width="20" height="20" />
            </div>
            <b v-else>{{ volume.displayValue }}</b>
          </div>
        </Tooltip>
      </div>
    </template>
  </div>
</template>

<script>
import { Tooltip } from 'element-ui'
import { mapState } from 'vuex'

export default {
    props: {
        volumes: {
            default: () => ([]),
            type: Array
        },

        chartColors: {
            default: () => ({}),
            type: Object
        },

        tooltipPlacement: {
            default: 'bottom',
            type: String
        },

        isOpen: {
            default: true,
            type: Boolean,
        },
    },

    components: {
        Tooltip,
    },

    computed: {
        ...mapState('builder', {
            formulaVolumesLoading: state => state.formulaVolumesLoading,
        }),
    },

    methods: {
        iconSize(volume) {
            const medium = ['total_users_mobile', 'total_users_firstid', 'total_firstid', 'total_users_crm', 'total_crm']
            if (medium.includes(volume.key)) return 'medium'
            return 'large'
        },
    }
}
</script>

<style lang="scss">
.volume-progress-chart {
  .volume-legend {
    line-height: 1;
    display: flex;
    // margin-right: 10px;
    justify-content: center;
    align-items: center;
    gap: 5px;
    &__item {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 30px;
        width: 30px;
        border-radius: 30px;
        color: #000 !important;
    }
    &__label {
        white-space: nowrap;
    }
  }
}

@media (min-width: 1200px) and (max-width: 1919px) {
  .volume-progress-chart {
    &__legend {
      &:not(.is-open) {
        .volume-legend {
          &__label {
            display: none;
          }
        }
      }
    }
  }
}
</style>
